/**
 * @file paddlehub demo 口罩识别入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import MaskDetectDemo from './MaskDetectDemo';
import './style.less';

export default MaskDetectDemo;
